const cssVariables = require('./css/lifeco');

const lifeCo = {
  routes: [
    '/term',
    '/term/',
    '/annuity',
    '/annuity/',
    '/disability',
    '/disability/',
  ],
  productMap: {
    annuity: 2,
    term: 3,
    disability: 5,
  },
  global: {
    appTitle: 'Life Co | Acquire',
    favicon: '',
    homepage: '/',
    carrierName: 'Life Co.',
    loader: '/images/animation_loading.gif',
  },
  branding: {
    lightLogo: '/images/lifeco_light_logo.png',
    darkLogo: '/images/lifeco_dark_logo.png',
    altText: 'Life Co',
    link: 'https://www.sureify.com/',
  },
  footer: {
    logo: '/images/lifeco_light_logo.png',
    altText: 'Life Co',
    phoneText: '669-342-6902',
    phoneNumber: '',
    disclaimerDesc: '2020 Life Co Insurance Company',
    supportPhoneNumber: '669-342-6902',
    socialLinks: [
      {
        id: 'facebook',
        icon: 'fa-facebook-f',
        linkFor: 'Facebook',
        linkUrl: 'https://www.facebook.com/LifeCo',
      },
      {
        id: 'twitter',
        icon: 'fa-twitter',
        linkFor: 'Twitter',
        linkUrl: 'https://www.twitter.com/LifeCo',
      },
      {
        id: 'linkedin',
        icon: 'fa-linkedin',
        linkFor: 'LinkedIn',
        linkUrl: 'https://www.linkedin.com/company/LifeCo/',
      },
      {
        id: 'youtube',
        icon: 'fa-youtube',
        linkFor: 'YouTube',
        linkUrl: 'https://www.youtube.com/LifeCo',
      },
      {
        id: 'pinterest',
        icon: 'fa-pinterest',
        linkFor: 'Pinterest',
        linkUrl: 'https://www.pinterest.com/LifeCo/',
      },
      {
        id: 'instagram',
        icon: 'fa-instagram',
        linkFor: 'Instagram',
        linkUrl: 'https://www.instagram.com/LifeCo/',
      },
    ],
    footerLinksTop: [],
    footerLinksBottom: [],
  },
  theme: {
    cssVars: cssVariables,
    global: {
      colorScheme: 'green',
      background: '#3b5369',
      leftSidebarColor: '#f7f7f7',
      footerBackground: '#3b5369',
      footerTextColor: '#ffffff',
      showPageInfo: true,
      breadcrumb: {
        active: {
          progressLabelColor: 'rgba(41, 101, 204, 1)',
          titleColor: 'rgb(59, 83, 105)',
          background: '#ffffff',
          imageOpacity: '1',
          border: '2px solid #98ACE6',
        },
        disabled: {
          progressLabelColor: 'black',
          titleColor: 'rgb(59, 83, 105)',
          background: 'rgba(179, 179, 179, 1)',
          imageOpacity: '0.5',
        },
      },
      colorOverride: {
        selectedBgColor: '#4589FF',
        checkedBg: '#4589FF',
        focusColor: '#4589FF',
        checkedFg: '#ffffff',
        fillBg: '#cccccc',
      },
      updateButton: {
        themeConfiguration: {
          selectedBgColor: 'rgb(69, 137, 255)',
          buttonBorder: '3px solid transparent',
          borderOnFocus: '3px solid black',
          borderBottom: '3px solid black',
          paddingLeft: '0px',
        },
      },
      removeButton: {
        themeConfiguration: {
          padding: '4px 0px 0px 0px',
          selectedBgColor: 'rgb(69, 137, 255)',
          margin: '0px 20px 0px 0px',
          buttonBorder: '3px solid transparent',
          borderOnFocus: '3px solid black',
          borderBottom: '3px solid black',
        },
      },
      logoutButton: {
        themeConfiguration: {
          selectedBgColor: 'rgb(69, 137, 255)',
          border: '1px solid rgb(69, 137, 255)',
          buttonBorder: '3px solid transparent',
          borderOnFocus: '3px solid black',
        },
      },
      prevButtonTheme: {
        themeConfiguration: {
          bgColor: 'rgb(69, 137, 255)',
          selectedBgColor: '#ffffff',
          border: '1px solid #ffffff',
          borderRadius: '4px',
          padding: '7.5px 16px',
          buttonBorder: '1px solid transparent',
          borderOnFocus: '2px solid black',
        },
        shape: 'rectangle',
        type: 'filled',
      },
      nextButtonTheme: {
        themeConfiguration: {
          bgColor: '#ffffff',
          selectedBgColor: 'rgb(69, 137, 255)',
          border: '1px solid #00c39c',
          padding: '7.5px 16px',
          disabledPadding: '8px 19px',
          margin: '3px 3px',
          focusMargin: '0px',
          borderRadius: '4px',
          buttonBorder: '1px solid transparent',
          borderOnFocus: '2px solid black',
          bgOnFocus: 'rgb(69, 137, 255)',
          supportWCAGTheme: true,
        },
        shape: 'rectangle',
        type: 'filled',
      },
      listButtonsTheme: {
        editButtonTheme: {
          themeConfiguration: {
            bgColor: 'rgb(84, 130, 213)',
            selectedBgColor: '#ffffff',
            buttonBorder: '3px solid transparent',
            borderOnFocus: '3px solid black',
          },
        },
        deleteButtonTheme: {
          themeConfiguration: {
            bgColor: 'rgb(255, 0, 0)',
            selectedBgColor: '#ffffff',
            buttonBorder: '3px solid transparent',
            borderOnFocus: '3px solid black',
          },
        },
        closeButtonTheme: {
          themeConfiguration: {
            bgColor: 'rgb(255, 0, 0)',
            selectedBgColor: '#ffffff',
            buttonBorder: '3px solid transparent',
            borderOnFocus: '3px solid black',
          },
        },
        listItemAddButtonTheme: {
          themeConfiguration: {
            bgColor: '#ffffff',
            selectedBgColor: 'rgb(69, 137, 255)',
            buttonBorder: '3px solid transparent',
            borderOnFocus: '3px solid black',
          },
        },
        borderOnFocus: '3px solid black',
      },
      commonButtonTheme: {
        borderOnFocus: '3px solid black',
      },
      modalButton: {
        themeConfiguration: {
          bgColor: '#ffffff',
          selectedBgColor: 'rgb(69, 137, 255)',
          padding: '5px 16px',
          buttonBorder: '3px solid transparent',
          borderOnFocus: '3px solid black',
        },
      },
      reactSelect: {
        focusColor: 'black',
        borderOnFocus: '3px solid black',
        placeholder: {
          color: '#767676',
        },
        selectLabel: {
          fontWeight: 'bold',
          color: '#767676',
        },
      },
      primaryButton: {
        shape: 'oval',
        color: 'blue',
      },
      text: {
        headingColor: '#454545',
        labelColor: '#767676',
        questionTextColor: '#5d5d5d',
        questionDescriptionColor: '#5d5d5d',
        sectionHeaderColor: '#ffffff',
      },
    },
    checkboxTheme: {
      themeConfiguration: {
        border: '1px solid rgba(153,153,153,1)',
        checkedBg: 'rgb(69, 137, 255)',
        inputBorder: '3px solid transparent',
        borderOnFocus: '3px solid black',
      },
    },
    components: {
      input: {
        floatingLabel: false,
        labelPosition: 'top',
        labelIsHTML: true,
        width: 'L',
        themeConfiguration: {
          inputBorder: '3px solid transparent',
          shouldFocusWithin: true,
          borderOnFocus: 'black',
        },
      },
      'autocomplete-text': {
        floatingLabel: false,
        labelPosition: 'top',
        labelIsHTML: true,
        width: 'L',
        themeConfiguration: {
          inputBorder: '3px solid transparent',
          shouldFocusWithin: true,
          borderOnFocus: '3px solid black',
        },
      },
      radio: {
        classic: {
          shape: 'classic',
          orientation: 'rows',
          themeConfiguration: {
            selectedBgColor: '#4589FF',
            checkedBg: '#4589FF',
            focusColor: '#4589FF',
            checkedFg: '#ffffff',
            fillBg: '#cccccc',
            margin: '1rem 0 2.4rem 0',
            borderOnFocus: '3px solid black',
          },
        },
        oval: {
          shape: 'oval',
          orientation: 'rows',
          themeConfiguration: {
            selectedBgColor: '#4589FF',
            checkedBg: '#4589FF',
            focusColor: '#4589FF',
            checkedFg: '#ffffff',
            fillBg: '#cccccc',
            borderOnFocus: '3px solid black',
          },
        },
        selectWrapper: {
          color: '#767676',
          borderOnFocus: '3px solid black',
        },
      },
      selectOption: {
        floatingLabel: false,
        labelPosition: 'top',
        labelIsHTML: true,
        width: 'L',
      },
      singleSelect: {
        shapeOverride: {},
        width: 'L',
        floatingLabel: false,
        labelIsHTML: true,
        labelPosition: 'top',
        plansPage: {
          labelWidth: 'auto',
        },
      },
      multiSelect: {
        width: 'L',
        floatingLabel: false,
        labelIsHTML: true,
        labelPosition: 'top',
      },
      datepicker: {
        width: 'L',
        floatingLabel: false,
        labelIsHTML: true,
        labelPosition: 'top',
        showPopper: true,
        guide: true,
        isDateChange: true,
        trackCalendarPopper: true,
      },
      card: {
        padding:
          'clamp(24px, 5%, 80px) clamp(16px, 5%, 100px) clamp(24px, 5%, 40px) clamp(16px, 5%, 100px)',
        showLeftBorder: false,
        themeConfiguration: {
          borderRadius: '8px',
        },
      },
      banner: {
        themeConfiguration: {
          borderRadius: '8px',
          padding: '30px',
          marginLeft: '0px',
        },
        buyNowButton: {
          themeConfiguration: {
            selectedBgColor: '#2865cc',
            bgColor: '#ffffff',
            border: '2px solid white',
            fontColor: '#333333',
            fontWeight: 'bold',
            fontSize: '16px',
            padding: '12px 14px',
            lineHeight: '20px',
            borderOnFocus: '2px solid white',
            margin: '14px 0 0 0',
          },
        },
      },
      progressCard: {
        borderRadius: '8px',
      },
    },
    pageOverrides: {
      quote: {
        input: {
          width: 'M',
          floatingLabel: false,
          labelPosition: 'top',
          labelIsHTML: false,
        },
        datepicker: {
          width: 'M',
          floatingLabel: false,
          labelPosition: 'top',
          labelIsHTML: false,
        },
        selectOption: {
          width: 'L',
          labelIsHTML: false,
          floatingLabel: false,
          labelPosition: 'top',
        },
        singleSelect: {
          width: 'M',
          floatingLabel: false,
          labelPosition: 'top',
          labelIsHTML: false,
        },
        multiSelect: {
          width: 'M',
          floatingLabel: false,
          labelPosition: 'top',
        },
        allowSectionScroll: true,
      },
      quotereview: {
        button: {
          width: '150%',
          shape: 'rounded',
          type: 'outlined',
          color: 'blue',
        },
        input: {
          width: 'M',
          floatingLabel: false,
          labelPosition: 'top',
          labelIsHTML: false,
        },
      },
      signature: {
        is_next_btn_hidden: false,
        is_prev_btn_hidden: true,
      },
      review: {
        headerColor: '#212529',
      },
    },
  },
  layout: {
    quote: 'quote',
    loader: 'single',
    questions: 'double',
    review: 'single',
    quoteResults: 'single',
    quotereview: 'single',
    plan: 'single',
    signature: 'single',
    payment: 'single',
    timeout: 'single',
    challenge: 'single',
    completed: 'single',
    products: 'single',
    static: 'single',
  },
  features: {
    login: {
      enable: true,
      loginURL: '/auth',
      logoutURL: '/auth/logout',
      refreshURL: '/auth/refresh_token',
      loginMethod: 'jwt',
    },
    sessionTimeout: {
      enable: false,
      triggerOnClose: true,
      timeout: {
        local: 10,
        development: 10,
        stg: 15,
        uat: 20,
        production: 20,
      },
    },
    liveChat: {
      enable: true,
      scriptSrc: 'https://api.salemove.com/salemove_integration.js',
    },
  },
};

module.exports = lifeCo;
